import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import AppHeader from '../../../components/Header/Header';
import AppFooter from '../../../components/Footer/footer';
import BannerSection from '../../../components/BannerSection';
import SectionHeading from '../../../components/SectionHeading';
import BreadcrumbNav from '../../../components/BreadcrumbNav';
import SidebarMenu from '../../../components/SidebarMenu';

// Separar os dados para manter o componente limpo
const CAMINHO_BREADCRUMB = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Programa' },
  { label: 'Unidade Orgânica' },
];

const UNIDADES_DATA = [
  {
    id: 1,
    image: require('../../../assets/UN_OR_04.jpg'),
    title: 'Engenharia',
    description: 'Transforme seu futuro com habilidades técnicas e inovadoras para projetar soluções que moldam o mundo moderno.',
    link: '/programas/unidade-organica/engenharia'
  },
  {
    id: 2,
    image: require('../../../assets/UN_OR_01.jpg'),
    title: 'Ciências da Saúde',
    description: 'Formação abrangente e prática para preparar profissionais dedicados a promover a saúde e o bem-estar.',
    link: '/programas/unidade-organica/ciencia-saude'
  },
  {
    id: 3,
    image: require('../../../assets/UN_OR_E_J.jpg'),
    title: 'Ciências Econômicas e Jurídicas',
    description: 'Formação sólida e multidisciplinar, preparando profissionais para atuar em diversas áreas do conhecimento humano.',
    link: '/programas/unidade-organica/ciencia-humanas'
  }
];

function UnidadeOrganica() {
  return (
    <div className="App" style={{ background: "#fdfdfd" }}>
      <header id="header">
        <AppHeader />
      </header>

      <BannerSection
        title="Unidade Orgânica"
        subtitle="Estrutura de Excelência Acadêmica"
        description="Gestão acadêmica e administrativa focada na qualidade do ensino e implementação de políticas institucionais do ISP-Atlântida."
        backgroundImage={require('../../../assets/BannerANU_ispa.jpg')}
        backgroundId="instituition-Banner"
      />

      <BreadcrumbNav items={CAMINHO_BREADCRUMB} />

      <main className="container-fluid px-md-5 py-5">
        <Row className="flex-row-reverse g-5">
          {/* Sidebar */}
          <Col lg={3} xl={2}>
            <SidebarMenu
              title="Programas"
              items={[
                { label: "Licenciatura", href: "/programas/licenciatura" },
                { label: "Unidade Orgânica", href: "/programas/unidade-organica" },
              ]}
            />
          </Col>

          {/* Conteúdo Principal */}
          <Col lg={9} xl={10}>
            <section className="mb-5">
              <SectionHeading title="Nossas Unidades" />
              <p className="lead text-secondary mt-3" style={{ maxWidth: '800px' }}>
                A Unidade Orgânica é o pilar de sustentação do Instituto Superior Politécnico Atlântida, 
                articulando a excelência pedagógica com a eficiência administrativa.
              </p>
            </section>

            <Row className="g-4">
              {UNIDADES_DATA.map((item) => (
                <Col md={6} xl={4} key={item.id}>
                  <Card className="h-100 border-0 shadow-sm custom-card">
                    <div className="img-wrapper">
                      <Card.Img
                        variant="top"
                        src={item.image}
                        className="card-img-custom"
                      />
                      <div className="img-overlay"></div>
                    </div>
                    <Card.Body className="p-4 d-flex flex-column">
                      <Card.Title className="fw-bold h5 mb-3">{item.title}</Card.Title>
                      <Card.Text className="text-muted mb-4 flex-grow-1">
                        {item.description}
                      </Card.Text>
                      <a href={item.link} className="btn-custom-link">
                        Conhecer Unidade <i className="bi bi-arrow-right ms-2"></i>
                      </a>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </main>

      <footer id="footer">
        <AppFooter />
      </footer>

      <style>{`
        .custom-card {
          border-radius: 16px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
        }

        .custom-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1) !important;
        }

        .img-wrapper {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .card-img-custom {
          height: 100%;
          width: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .custom-card:hover .card-img-custom {
          transform: scale(1.1);
        }

        .img-overlay {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.4));
        }

        .btn-custom-link {
          text-decoration: none;
          color: #198754;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          transition: color 0.2s;
        }

        .btn-custom-link:hover {
          color: #146c43;
          text-decoration: underline;
        }

        .lead {
          font-size: 1.1rem;
          line-height: 1.7;
        }
      `}</style>
    </div>
  );
}

export default UnidadeOrganica;